import state from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import related from "@/store/modules/account/new-order/related/index";

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    related,
  }
};